import client from '@api/client';

/**
 * 사용자 및 인증 관련 API 모음
 */
const userApi = {
  // 회원가입
  signup: async ({ email, password, nickname }) => {
    return await client.post('/api/auth/signup', { email, password, nickname });
  },

  // 로그인 (OAuth2 폼 데이터 전송)
  login: async ({ email, password }) => {
    const formData = new URLSearchParams();
    formData.append('username', email);
    formData.append('password', password);
    const doLogin = () => client.post('/api/auth/login', formData, {
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
    });

    try {
      return await doLogin();
    } catch (error) {
      // 백엔드가 요청을 아예 못 받았을 때(연결거부·재시작 창)만 1회 재시도한다 — client.js 의
      // GET 전용 재시도(502/503/504)가 POST 인 로그인은 안 잡아 준다. 이 상태코드들은 로그인
      // 라우터가 직접 던지는 값이 아니라(라우터는 400/429만 던진다) 프록시·서버 자체가 요청을
      // 못 받았을 때만 나오므로 재시도해도 부작용이 없다 — 진짜 "비밀번호 틀림"은 400이라 안 걸린다.
      const isTransient = !error.response || [500, 502, 503, 504].includes(error.response.status);
      if (isTransient) {
        await new Promise((r) => setTimeout(r, 1000));
        return await doLogin();
      }
      throw error;
    }
  },

  // 임시 관리자/게스트 로그인 접근을 위한 우회 API
  guestLogin: async () => {
    return await client.post('/api/auth/guest-login');
  },

  // 바로입장 — 브로큰N 계정을 만들고 토큰·아이디·비번을 함께 받는다
  quickStart: async () => {
    return await client.post('/api/auth/quick-start');
  },

  // 내 계정(아이디·닉네임·바로입장 정리 예정일) 조회 · 변경
  getMyAccount: async () => {
    return await client.get('/api/auth/me/account');
  },
  updateMyAccount: async (body) => {
    return await client.patch('/api/auth/me/account', body);
  },

  // 로그아웃 (서버 상태 변경)
  logout: async () => {
    return await client.post('/api/auth/logout');
  },

  // 접속자 수 + 총 가입자 수 요약 (로그인 화면 배지용, 인증 불필요)
  getStatsSummary: async () => {
    return await client.get('/api/auth/stats/summary');
  },

  // 로그인 화면 체류 신호 — 서버는 sid 를 75초 TTL 로 들고 있다가 로비 인원을 센다.
  // 계정과 무관한 익명 id 라 로그인 전에도 보낼 수 있다.
  sendLobbyBeat: async (sid) => {
    return await client.post('/api/auth/stats/lobby-beat', { sid });
  },

};

export default userApi;
